module.exports = __webpack_public_path__ + "static/media/reports-icon.d7d652be.svg";